export default __webpack_public_path__ + "static/mobile_wireframe_cover-731868eaddeb845075f27a72c12a88ea.png";